import React, { useState } from "react";
import styled from "styled-components";
import { withI18n } from "react-i18next";

interface IProps {
  t?: any;
}

const ActorSellingFeatures: React.FC<IProps> = ({ t }) => {
  return (
    <>
      <TitleWrapper>
        <MainTile>{t("Actor")}</MainTile>
      </TitleWrapper>
      <StyledP>
        {t(
          "One membership gives you all the tools you need to break into & thrive in the acting business:"
        )}
      </StyledP>
      <Container>
        <Detail>
          <DetailImg src="../images/selling_one.png" />
          <DetailRight>
            <Title>
              <Point></Point> {t("Receive Agent Auditions, Self-Tape & Find Jobs")}
            </Title>
            <Content>
              {t(" The big productions hire casting directors who post directly to agents so having an agent matters!")}
              <br></br>
              <br></br>
              {t("But don't worry if you don’t have an agent yet! Most small and many big projects go out directly to actors for those hard to cast roles.")}
            </Content>
          </DetailRight>
        </Detail>
        <Detail>
          <DetailImg src="../images/selling_two.png" />
          <DetailRight>
            <Title>
              <Point></Point> {t("Get Submitted or if not repped, submit directly to open roles.")}
            </Title>
            <Content>
              {t("You and your agent, get multiple resumes, headshots, submissions to jobs and casting director searches.")}
            </Content>
          </DetailRight>
        </Detail>
      </Container>
    </>
  );
};

export default withI18n()(ActorSellingFeatures);

const TitleWrapper = styled.div`
  width: 100%;
`;

const MainTile = styled.h1`
  font-size: 32px;
  font-weight: 600;
  line-height: 44px;
  color: #0a1f44 !important;
  margin-bottom: 12px;
  @media all and (max-width: 768px) {
    padding-right: 15px;
    padding-left: 15px;
  }
`;

const StyledP = styled.p`
  font-size: 16px;
  color: #364866 !important;
  line-height: 22px;
  @media all and (max-width: 768px) {
    width:100%;
    padding-right: 15px;
    padding-left: 15px;
  }
`;

const Container = styled.div`
max-width: 530px;
left: 133px;
top: 202px;

padding-top:24px;
border-radius: 2px;
display:flex;
flex-direction:column;
justify-content:space-evenly;

@media all and (max-width: 768px) {
  width:100%;
  background: #FFFFFF;
  padding:24px;
}
`;

const Detail = styled.div`
width:100%;
display:flex;
justify-content:space-between;
margin-bottom:40px;
@media all and (max-width: 768px) {
  flex-direction:column;
  margin-bottom:0;
}
`;

const DetailImg = styled.img`
width:40%;
object-fit: contain;
@media all and (max-width: 768px) {
  width:100%;
  margin-bottom:24px;
  min-height: 205px;
}
`;

const DetailRight = styled.div`
width:55%;
display:flex;
flex-direction:column;
@media all and (max-width: 768px) {
  width:100%;
}
`;

const Title = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
`;

const Point = styled.span`
color: #00AAFF;
`;

const Content = styled.div`
margin-top:8px;
font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 15px;
/* or 107% */

letter-spacing: 0.374px;

/* Greys/700 */

color: #53627C;
`;


